import React from 'react';
import { connect } from "react-redux";
import queryString from 'query-string';
import { setUserProfile } from '@app/state/actions';
import { PROFESSIONAL } from '@app/constants/userTypes';
import * as paths from '@app/constants/paths';

import WizardView from './WizardView';

class ConnectedWizardContainer extends React.Component {
    constructor(props) {
        super(props);
        const queryParams = queryString.parse(this.props.location.search);
        const maxSteps = 9;
        const completedSteps = [];
        for (let i = 0; i < maxSteps; i++) {
            completedSteps.push(false);
        }
        this.state = {            
            maxSteps: maxSteps,
            completedSteps: completedSteps,
            currentStep: queryParams.step ? Number(queryParams.step) : -1,
            isLoading: false,
            successMessage: '',
            errorMessage: ''
        };

        this.setCurrentStep = this.setCurrentStep.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.cancel = this.cancel.bind(this);
        this.setIsLoading = this.setIsLoading.bind(this);
        this.setSuccessMessage = this.setSuccessMessage.bind(this);
        this.setErrorMessage = this.setErrorMessage.bind(this);
        this.resetMessages = this.resetMessages.bind(this);
        this.setIsLoading = this.setIsLoading.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    setCurrentStep(value) {
        const completedSteps = this.state.completedSteps;
        completedSteps[value] = false;
        this.setState({
            completedSteps: completedSteps
        });
        this.setState({
            currentStep: value,
        });
    }

    nextStep() {
        const maxSteps = this.state.maxSteps;
        const currentStep = this.state.currentStep;
        const completedSteps = this.state.completedSteps;
        completedSteps[currentStep] = true;
        this.setState({
            completedSteps: completedSteps
        });
        if (currentStep < maxSteps -1 ) {
            this.setCurrentStep(currentStep + 1);
        }        
    };

    previousStep() {
        const currentStep = this.state.currentStep;
        if (currentStep > 0) {
            this.setCurrentStep(currentStep - 1);
        }        
    };

    cancel() {
        this.setCurrentStep(0);
        this.resetMessages();
        this.props.history.push(paths.LANDING);
    }

    setIsLoading(isLoading) {
        this.setState({
            isLoading: isLoading
        });
    }

    setSuccessMessage(successMessage) {
        this.setState({
            successMessage: successMessage
        });
    }

    setErrorMessage(errorMessage) {
        this.setState({
            errorMessage: errorMessage
        });
    }

    resetMessages() {
        this.setState({
            successMessage: '',
            errorMessage: ''
        });
    }

    generateViewProps() {
        return {
            history: this.props.history,
            locale: this.props.locale,
            continuePath: this.props.continuePath,
            completedSteps: this.state.completedSteps,
            currentStep: this.state.currentStep,
            isLoading: this.state.isLoading,
            successMessage: this.state.successMessage,
            errorMessage: this.state.errorMessage,
            setCurrentStep: this.setCurrentStep,
            nextStep: this.nextStep,
            cancel: this.cancel,
            setIsLoading: this.setIsLoading,
            setSuccessMessage: this.setSuccessMessage,
            setErrorMessage: this.setErrorMessage,
            resetMessages: this.resetMessages
        }
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <WizardView  {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale,
        continuePath: state.continue.continuePath
    }
}

const WizardContainer = connect(mapStateToProps)(ConnectedWizardContainer);
export default WizardContainer;


